import { render, staticRenderFns } from "./ScenariosUnlockedPopup.vue?vue&type=template&id=51e71987&scoped=true&"
import script from "./ScenariosUnlockedPopup.vue?vue&type=script&lang=js&"
export * from "./ScenariosUnlockedPopup.vue?vue&type=script&lang=js&"
import style0 from "./ScenariosUnlockedPopup.vue?vue&type=style&index=0&id=51e71987&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e71987",
  null
  
)

/* custom blocks */
import block0 from "./ScenariosUnlockedPopup.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports